import React from "react";
import { usePrinterExtraStore } from "../../state/storePrinterExtra";

type Props = {};

const LeftPrinter = (props: Props) => {
  const {
    printer_left1,
    printer_left2,
    printer_left3,
    printer_left4,
    printer_left5,
    printer_left6,
    printer_left7,
  } = usePrinterExtraStore((state) => state);
  return (
    <div className="">
      <p>{printer_left1}</p>
      <p>{printer_left2}</p>
      <p>{printer_left3}</p>
      <p>{printer_left4}</p>
      <p>{printer_left5}</p>
      <p>{printer_left6}</p>
      <p>{printer_left7}</p>
    </div>
  );
};

export default LeftPrinter;
